import { removeUserPhone, setDefaultPhone } from './../../Api/userApi';
import { notifyError } from './../../Services/vueNotifier';
import { apiErrorList } from 'Services/restAdviser';
import { ApiUserPhoneResult, ApiUserPhoneCheck } from './../../Types/UserPhone/Api';
import { account } from './../../routes';
import { CancelToken } from 'axios'
import { uploadFile } from 'Api/uploadApi'
import { parseUserAccount } from 'Parsers/userAccountParser'
import { formatUserAccountAsync } from 'Formatters/userAccountFormatter'
import { getUserInfo, editUserInfo, uploadUserAvatar, addPhoneValid} from 'Api/userApi'
import cloneDeep from 'lodash/cloneDeep'
import { getPhone, addPhone, getPhoneList, checkPhone, removePhone, refreshPhoneToken } from 'Api/userPhoneApi'

const state = {

  requesting: {
    info: false,
    infoSubmit: false,
    avatarUpload: false,
    sendValidation: false,
    phoneCheck: false,
    phoneValidation: false,
    addPhoneValid: false,
  },

  status: {
    isDirty: null,
  },

  info: {
    id: 0,
    name: '',
    avatar: '',
    occupation: '',
    otherOccupation: '',
    birthday: '',
    email: '',
    typeReceivement: {
      typeReceivementValue: null
    },
    photoList: [],
    verifiedPhone: false,

  },

  phone: {
    id: 0,
    ddd: '',
    number: '',
  },

  cancelToken: {
    gallery: null,
    logo: null,
  },

  phoneToken: '',

  errorList: [],
  errorMessage: '',
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },
  set_info(state, info) {
    state.info = info
  },
  set_user_avatar(state, avatar) {
    state.info.avatar = avatar
  },

  set_cancel_token(state, { type, token }) {
    state.cancelToken[type] = token
  },

  set_phone_token(state, token) {
    state.phoneToken = token
  },

  set_phone_validation(state, { errorList, isDirty, errorMessage }) {
    state.errorList = errorList
    state.errorMessage = errorMessage
    state.status.isDirty = isDirty
  },
  set_ddd(state, ddd ) {
    state.phone.ddd = ddd

  },
  set_phone_number(state, number ) {
    state.phone.number = number
  },

  set_verified_phone(state, verifiedPhone) {
    state.info.verifiedPhone = verifiedPhone
  },

}

const actions = {
  async getInfo({ commit }) {
    commit('request_start', 'info')

    try {
      const { data } = await getUserInfo()
      const info = parseUserAccount(data)

      commit('set_info', info)

      commit('request_success', 'info')

      return data
    } catch (err) {
      commit('request_failure', 'info')

      throw err
    }
  },

  async submitInfo({ commit, dispatch }, info) {
    commit('request_start', 'infoSubmit')

    try {
      const data = await formatUserAccountAsync(info)
      const result = await editUserInfo(data)

      await dispatch('account/refreshAccountInfo', null, { root: true })

      commit('request_success', 'infoSubmit')

      return result
    } catch (err) {
      commit('request_failure', 'infoSubmit')

      throw err
    }
  },

  async uploadAvatar({ commit, dispatch }, { file, logger }) {
    commit('request_start', 'avatarUpload')

    try {
      // @ts-ignore
      const logoToken = CancelToken.source()

      commit('set_cancel_token', {
        type: 'avatar',
        token: logoToken
      })

      const { data } = await uploadFile(file, logger, logoToken.token)
      const result = await uploadUserAvatar(data.path)

      await dispatch('account/refreshAccountInfo', null, { root: true })

      commit('set_user_avatar', result.data.photoUrl)

      commit('request_success', 'avatarUpload')

      return result
    } catch (err) {
      commit('request_failure', 'avatarUpload')

      throw err
    }
  },

  updateInfo({ commit, state }, info) {
    commit('set_info', Object.assign(
      cloneDeep(state.info),
      info
    ))
  },

  cancelUpload({ commit, state }, type) {
    const { cancelToken } = state

    if (cancelToken[type] !== null) {
      const { cancel } = cancelToken[type]

      cancel()
    }

    commit('set_cancel_token', {
      type: type,
      token: null
    })
  },

  updateValidation({ commit, state }, options) {
    const isDefined = (value) => typeof value !== 'undefined'


    const errorList = isDefined(options.errorList)
      ? options.errorList
      : state.errorList

    const isDirty = isDefined(options.isDirty)
      ? options.isDirty
      : state.status.isDirty

    const errorMessage = isDefined(options.errorMessage)
      ? options.errorMessage
      : state.errorMessage

    const validation = {
      errorList,
      isDirty,
      errorMessage,
    }

    commit('set_phone_validation', validation)
  },

  updateInfoDDD({ commit }, ddd){
    commit('set_ddd', ddd)
  },

  updateInfoPhoneNumber({ commit }, phoneNumber){
    commit('set_phone_number', phoneNumber)
  },

  async createPhoneForVerification({ state, commit }) {
    const { ddd, number } = state.phone
    const { typeReceivementValue } = state.info.typeReceivement
    try {
      const { data } = await addPhone(ddd, number, typeReceivementValue)
      commit('set_phone_token', data.token)
      return data.token
    } catch (err) {
      throw err
    }
  },

  async deletePhone({ commit }, phone: ApiUserPhoneResult) {
    const { data } = await removePhone(phone.id)

    return data
  },

  async deleteUserPhone({ commit, dispatch }, id: number) {
    const { data } = await removeUserPhone(id)
    dispatch('getInfo')

    return data
  },

  async requestPhoneVerification({ state, commit, dispatch }) {
    commit('request_start', 'phoneCheck')

    try {
      const { ddd, number } = state.phone
      const { data } = await getPhoneList()

      const phone = data.find(item =>
        item.number === number && item.localCodeArea === ddd
      )

      if (phone) {
        await dispatch('deletePhone', phone)
      }

      const token = await dispatch('createPhoneForVerification')

      commit('request_success', 'phoneCheck')

      return token
    } catch (err) {

      commit('request_failure', 'phoneCheck')

      throw err
    }
  },

  async validatePhone({ commit, dispatch }, payload: ApiUserPhoneCheck) {
    commit('request_start', 'phoneValidation')

    try {
      const { data } = await checkPhone(payload)
      dispatch('updateValidation', { errorList: [], invalidStep: null })
      commit('set_verified_phone', true)


      dispatch('addPhoneValid')

      commit('request_success', 'phoneValidation')

      return data
    } catch (err) {
      commit('request_failure', 'phoneValidation')

      throw err
    }
  },
  async refreshPhoneToken({ state }) {
    const { ddd, number } = state.phone
    const { typeReceivementValue } = state.info.typeReceivement
    try {
      const { data } = await refreshPhoneToken(ddd, number, typeReceivementValue)

      return data.token
    } catch (err) {
      throw err
    }
  },

  async defaultPhone({ state, dispatch }, id: number) {
    try {
    const { data } = await setDefaultPhone(id)

    dispatch('getInfo')

    return data
    } catch (err) {
      throw err
    }
  },

  async addPhoneValid({commit, state, dispatch}) {
    commit('request_start', 'addPhoneValid')
    try {
      const payload = {
        id: state.phone.id,
        ddd: state.phone.ddd,
        number: state.phone.number.replace('-', ''),
        ddi: '55',
        isVerified: true
      }
      const {data} = await addPhoneValid(payload)

      dispatch('getInfo')
      dispatch('resetPhone')

      commit('request_success', 'addPhoneValid')

      return data
    } catch (error) {
      commit('request_failure', 'addPhoneValid')
    }
  },

  resetPhone({ commit }) {
    commit('set_phone_number', '')
  }
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}